import styled from "styled-components";

import P from "components/P";

const PAd = styled(P)`
  font-size: 14px;
  color: #333333;
  margin: 0;

  @media (min-width: 992px) {
    font-size: 19px;
  }
`;

export default PAd;